export const theme = {
  colors: {
    primary: {
      start: '#B8A44E',
      end: '#ec4899',
      gold: '#FFD700'
    },
    background: {
      primary: '#000000',
      secondary: '#0A0A0A',
      gradient: 'linear-gradient(to right, var(--tw-gradient-from) 0%, var(--tw-gradient-to) 100%)'
    },
    text: {
      primary: '#FFFFFF',
      secondary: '#9CA3AF',
      gradient: 'text-transparent bg-clip-text bg-gradient-to-r from-primary-start to-primary-end'
    },
    border: {
      primary: 'border-primary-start/20'
    },
    hover: {
      gradient: 'hover:bg-gradient-to-r hover:from-primary-start/10 hover:to-primary-end/10'
    }
  }
};

export const gradientText = "text-transparent bg-clip-text bg-gradient-to-r from-primary-start to-primary-end";
export const gradientBorder = "border border-primary-start/20";
export const gradientHover = "hover:bg-gradient-to-r hover:from-primary-start/10 hover:to-primary-end/10";
export const gradientButton = "bg-gradient-to-r from-primary-start to-primary-end hover:from-primary-start/90 hover:to-primary-end/90";